import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';
import { PageURL } from 'src/app/pages/pages';
import { AuthenticationService } from '../services/authentication.service';


@Injectable({
  providedIn: 'root'
})
class PermissionsService {
  PageURL: typeof PageURL = PageURL;

  constructor(private readonly auth: AuthenticationService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.auth.checkStorage().then(res => {
      // if logged in, deny access back to login page
      if (res) {
        // if login page is directly accessed via url, this prevents an infinite loop
        // else, returns to previous page
        if (state.url.toString() == PageURL.EMPTY) {
          this.router.navigate(['/accounts'], { queryParams: { returnUrl: state.url }});
        }
        if (state.url.toString() == PageURL.WELCOME) {
          this.router.navigate(['/'], { queryParams: { returnUrl: state.url }});
        }
        if (state.url.toString().startsWith(PageURL.REGISTER) || state.url.toString().startsWith(PageURL.FORGOTPASSWORD)) {
          this.router.navigate(['/']);
        }
       
        return false;
      }
      return true;
    });
  }
}

export const LoginGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  return inject(PermissionsService).canActivate(next, state);
}
